"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const BaseComponent_1 = require("@src/app/commons/BaseComponent");
const Constants_1 = require("@src/app/commons/Constants");
const plugin_controller_1 = require("@src/app/commons/plugins/plugin-controller");
const plugin_manager_service_1 = require("@src/app/service/plugin-manager.service");
const application_events_service_1 = require("../../events/application-events.service");
const ui_manager_service_1 = require("../ui-manager.service");
class XsWidgetPopoverComponent extends BaseComponent_1.BaseComponent {
    constructor(
    // the three BaseComponent services
    router, snackBar, dialog, 
    // others we need
    uiManager, applicationEvents, pluginManager) {
        super(router, snackBar, dialog);
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.uiManager = uiManager;
        this.applicationEvents = applicationEvents;
        this.pluginManager = pluginManager;
        this.debug = false;
        // what plugin is in action
        this.plugin = null;
        // any item attached? (Transform, Scene, Annotation, etc.)
        this.item = null;
        // What's the context? Who's calling the shots?
        this.context = this;
        // id for the popover panel itself
        this.id = null;
        // track state of hovering plugin menus
        this.hovers = {};
        // state and selected pre and actual items
        this.pre_selected_hover_item = null;
        this.selected_hover_item = null;
        if (this.debug) {
            console.log('PopoverCOMPONENT %c [dunnoyet] %c CONSTRUCT', Constants_1.Constants._pink, Constants_1.Constants._pink);
        }
    }
    // look for changes to the @input variables
    ngOnChanges() {
        if (this.debug) {
            console.log('Popover %c [dunnoyet] %c ngChanges() ', Constants_1.Constants._pink, Constants_1.Constants._pink, this.pluginController, this.controller);
        }
        if (this.pluginController) {
            this.pluginController.injectComponent(this);
        }
        // this controller is the popover controller (works as a bridge between the popower 
        // component and where it works from, for example layers.comp or map.comp, etc.)
        if (this.controller) {
            this.controller.injectComponent(this);
            // different contexts bring different plugin controllers
            if (this.controller.pluginController) {
                this.pluginController = this.controller.pluginController;
            }
        }
    }
    init() {
        // just use the component UUID as the popover id
        this.id = this.__ID.instance;
        if (this.debug) {
            console.log('Popover %c ' + this.__ID.instance + ' %c COMPONENT INIT', Constants_1.Constants._pink, Constants_1.Constants._pink);
        }
    }
    clickPluginShortcut(plugin, item, event = null) {
        let me = this;
        if (this.debug) {
            console.log('Popover %c ' + this.__ID.instance + ' %c COMPONENT clickPluginShortcut', Constants_1.Constants._pink, Constants_1.Constants._pink, plugin.active, plugin, item.id);
        }
        if (plugin.active) {
            if (this.debug) {
                console.log('Popover %c ' + this.__ID.instance + ' %c COMPONENT clickPluginShortcut ACTIVE', Constants_1.Constants._pink, Constants_1.Constants._pink, plugin);
            }
            // already running
            this.activate(plugin, item, event);
        }
        else {
            if (this.debug) {
                console.log('Popover %c ' + this.__ID.instance + ' %c COMPONENT clickPluginShortcut NOT ACTIVE', Constants_1.Constants._pink, Constants_1.Constants._pink, plugin);
            }
            // not running; start one up
            plugin.id = this.pluginController.create(plugin.name, null, item);
            if (this.debug) {
                console.log('Popover %c ' + this.__ID.instance + ' %c COMPONENT clickPluginShortcut CREATED', Constants_1.Constants._pink, Constants_1.Constants._pink, plugin);
            }
            setTimeout(() => { me.activate(plugin, item, event); }, 500);
        }
    }
    // activate the popover
    activate(plugin, item, event = null) {
        if (this.debug) {
            console.log('PopoverCOMPONENT %c ' + this.__ID.instance + ' %c activate', Constants_1.Constants._pink, Constants_1.Constants._pink);
        }
        let p = this.pluginManager.get(plugin.id);
        this.item = item;
        this.plugin = p;
        // let find = ('plugin-ui-' + plugin.id).trim();
        // let box = event.srcElement;
        let pop = document.getElementById(this.id + 'pop');
        console.log('## pop', pop, event, this.plugin.meta);
        if (pop && event && event.clientY) {
            let y = (event.clientY + 15);
            // let pos:number = (document.documentElement.scrollTop || document.body.scrollTop) + document.documentElement.offsetHeight;
            let max = document.documentElement.scrollHeight;
            if (max - y < 330) {
                y = max - 330;
            }
            pop.style.top = y + 'px';
            const rect = event.target.getBoundingClientRect();
            if (this.plugin.meta.offsetX && this.plugin.meta.offsetX == 'context') {
                pop.style.left = rect.left + window.pageXOffset - 20 + 'px';
            }
            if (this.plugin.meta.offsetY && this.plugin.meta.offsetY == 'context') {
                pop.style.top = rect.top + window.pageYOffset + 20 + 'px';
            }
            // give it some time for the sub-components to draw their content
            setTimeout(() => {
                // get the id of the UI plugin inner box, and adjust its max height so it doesn't cut below the bottom of the screen
                let box = document.getElementById(('plugin-ui-' + plugin.id).trim());
                if (box) {
                    box.style.maxHeight = (max - y) - 50 + 'px';
                }
                // console.log('@@@', y, pos, max, (max - y) - 50, find );
            }, 100);
        }
    }
    // deactivate / close the popover
    close() {
        this.item = null;
        this.plugin = null;
        if (this.debug) {
            console.log('popover %c ' + this.__ID.instance + ' %c close', Constants_1.Constants._pink, Constants_1.Constants._pink, this.item, this.plugin);
        }
    }
    // all mouse over, hover and pop stuff
    mouseHoverClick(inp, $event = null) {
        this.pre_selected_hover_item = inp;
        this.mouseHoverForReal(inp, $event);
    }
    // mousehover() is debouncing mousehoverforreal()
    mouseHover(inp, $event = null) {
        this.pre_selected_hover_item = inp;
        let me = this;
        setTimeout(() => {
            me.mouseHoverForReal(inp, $event);
        }, 800);
    }
    // ok, the preselected item is still there, so make it a proper hover
    mouseHoverForReal(inp, $event = null) {
        if (this.debug) {
            console.log('PopoverController %c ' + this.__ID.instance + ' %c real', Constants_1.Constants._pink, Constants_1.Constants._pink, inp, $event);
        }
        if (this.pre_selected_hover_item) {
            this.pre_selected_hover_item = null;
            this.selected_hover_item = inp;
            let id = inp.id;
            // console.log('hover real', id, inp );
            if (!this.hovers[id]) {
                this.hovers[id] = {
                    hovering: false
                };
            }
            if (this.hovers[id].hovering) {
                return;
            }
            this.hovers[id].hovering = true;
            // find the element where the action started
            // let find = document.getElementById('plugin-hover-for-'+id);
            let find = $event.srcElement;
            let pop = document.getElementById(this.id + 'hover');
            if (this.debug) {
                console.log('PopoverController %c ' + this.__ID.instance + ' %c hover', Constants_1.Constants._pink, Constants_1.Constants._pink, this.id, find, pop);
            }
            if (find && pop) {
                let pos = find.getBoundingClientRect();
                // let markerpos = this.marker.getBoundingClientRect();
                pop.style.top = pos.top - 8 + 'px';
                pop.style.left = pos.left - 8 + 'px';
                if (this.debug) {
                    console.log('PopoverController %c ' + this.__ID.instance + ' %c hover style', Constants_1.Constants._pink, Constants_1.Constants._pink, pos, pop.style.top, pop.style.left);
                }
            }
        }
    }
    // leaving the icon means kill the preselected hover to go through (mouse moved on)
    mouseLeaveIcon(inp = null, $event = null) {
        this.pre_selected_hover_item = null;
    }
    // this leave is leaving the popover menu
    mouseLeave(inp) {
        if (inp) {
            let id = inp.id;
            // console.log('leave', id, inp );
            if (this.hovers[id] && this.hovers[id].hovering) {
                this.hovers[id].hovering = false;
                let pop = document.getElementById(this.id + 'hover');
                if (pop) {
                    // move the popover out of sight
                    pop.style.top = '-101px';
                    pop.style.left = '-101px';
                }
                // console.log('leave',inp);
            }
            this.selected_hover_item = null;
            this.pre_selected_hover_item = null;
        }
    }
    clickedPluginsHover(name = null, inp = null, event = null) {
        let me = this;
        let thisone = this.selected_hover_item;
        if (inp) {
            let newid = this.pluginController.create(name, null, inp);
            setTimeout(() => {
                let plugin = me.pluginController.getById(newid);
                this.activate(plugin, thisone, event);
            }, 100);
        }
        if (this.selected_hover_item) {
            this.mouseLeave(this.selected_hover_item);
        }
    }
}
exports.XsWidgetPopoverComponent = XsWidgetPopoverComponent;
